export enum SYSTEM_SHIPMENT_EVENT {
  SHIPMENT_CREATED = 'shipment_status_created',
  SHIPMENT_CLOSED = 'shipment_status_closed',
  SEGMENT_CREATED = 'segment_status_created',
  MARKED_AS_NOT_DELIVERED = 'shipment_status_in_transit',
  QR_WEBPAGE_ACCESS = 'qr_webpage_access',
  USER_ACCEPTED_DELIVERY = 'accept_delivery',
  USER_REJECTED_DELIVERY = 'reject_delivery',
  DELIVERY_ACTION_EXPECTED_SHIPMENT_EVENT = 'delivery_action_expected_shipment_event',
  WORKFLOW_GROUP_CHANGE_SHIPMENT_EVENT = 'workflow_group_change_shipment_event'
}

export type SystemEventsLabels = {
  [key in SYSTEM_SHIPMENT_EVENT]: string;
};